{
  "variableTypeFamilies": {
    "NumVar": "number",
    "ColorVar": "color",
    "PercentageVar": "percentage",
    "OpacityVar": "percentage"
  },
  "schemaValueTypeContracts": {
    "CSS.Color": {
      "compoundSlotFamilies": [
        "number",
        "percentage"
      ],
      "supportedFunctions": [
        "rgb",
        "rgba"
      ]
    }
  },
  "cssVarNamePattern": "^[a-zA-Z0-9-_]+$"
}
